import { Balance, Money } from 'mbs-ui-shared@components/components/models/license.model';
import { NAValue } from 'mbs-ui-shared@components/licenses/constants/license';

export function getPostPaymentPrice(balance: Balance, value: Money | string | number, period?: string) {
  const currency = balance?.subscriptionCurrencySign || '$';

  if (typeof value === 'string' && value.includes(NAValue)) {
    return NAValue;
  }

  if (typeof value === 'object') {
    const price = `${value?.currencyName || currency}${value?.integerValue}.${value?.remainderValue}`;
    return value ? (period ? `${price} / ${period}` : price) : '—';
  } else {
    return period ? `${currency}${value} / ${period}` : `${currency}${value}`;
  }
}
